/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettlementDisplayComponentsTypeEnum {
    HEADER = 'HEADER',
    INFORMATION = 'INFORMATION',
    SECTION_TITLE = 'SECTION_TITLE',
    AGREEMENT = 'AGREEMENT',
    FOOTER = 'FOOTER'
}
